import React, { ReactNode } from "react"
import Text from "../../../../../components/Text"
import { styled, theme } from "../../../../../styles/stitches.config"
import { Span } from "../../../../../components/span/Span"
import { ProgressBar } from "./ProgressBar"

type Props = {
  children: ReactNode
  stepsNum: number
  maxSteps: number
  subHeading?: ReactNode
}

const Steps = styled(Span, {
  textAlign: "center",
  color: theme.colors.secondary,
  fontWeight: theme.fontWeights.bold,
  fontSize: theme.sizes.s4,
  marginBottom: theme.sizes.s3,
  display: "block",
})

const styledHeader = {
  lineHeight: theme.sizes.s8_5,
  fontWeight: theme.fontWeights.bold,
  textAlign: "center",
  display: "block",
}

const styledSubheading = {
  lineHeight: theme.sizes.s8_5,
  fontSize: theme.sizes.s3_5,
  textAlign: "center",
  display: "block",
}

export function SectionHeader(props: Props) {
  const { children, stepsNum, subHeading, maxSteps } = props

  return (
    <>
      <Steps>
        Krok {stepsNum} z {maxSteps}
      </Steps>
      <ProgressBar stepsNum={stepsNum} sections={Array.from({ length: maxSteps })} />
      <Text type="headerH1" css={{ ...styledHeader }}>
        {children}
      </Text>
      {subHeading && (
        <Text type="labelsAlt" css={{ ...styledSubheading }}>
          {subHeading}
        </Text>
      )}
    </>
  )
}
